import {
  CountryFlag,
  isEnterKey,
  RadioButton,
  Resource,
  useSession,
} from '@travelwin/core';

import { useCountryUtils } from '../../../hooks/useCountryUtils';
import { changeLanguage } from '../../../i18n';
import {
  OnlineShopTerritory,
  useCountriesDomainQuery,
} from '../../../services/resources/ResourceService';
import { isSameHostname } from '../../../utils/urlUtils';

type CountrySwitchProps = {
  className: string;
  groupName?: string;
  onPanelClose: () => void;
};

const CountrySwitch = ({
  className: rootClassName,
  groupName = 'store',
  onPanelClose,
}: CountrySwitchProps) => {
  const { getCountryNameTranslation } = useCountryUtils();

  const { sessionId, visitorOrigin } = useSession();

  const { data: countriesDomain } = useCountriesDomainQuery();

  const itemToString = (country: Resource | null): string => {
    return country?.description
      ? getCountryNameTranslation(country.description)
      : '';
  };

  const handleCountryChange = (selectedCountry: OnlineShopTerritory) => {
    if (selectedCountry.locale) {
      changeLanguage({
        language: selectedCountry.locale,
        sessionId,
        visitorOrigin,
      });
    }

    onPanelClose();
    window.location.assign(selectedCountry.url);
  };

  return (
    <div className={`${rootClassName}--panel`}>
      {countriesDomain?.map((country, index) => (
        <RadioButton
          key={country.id}
          value={country.id}
          isChecked={isSameHostname(
            new URL(location.href),
            new URL(country.url),
          )}
          onClickLabel={() => handleCountryChange(country)}
          onKeyDownLabel={(e) => isEnterKey(e) && handleCountryChange(country)}
          onClick={() => handleCountryChange(country)}
          label={itemToString(country)}
          group={groupName}
          data-testid={`input-typeahead-item-${index}`}
          icon={<CountryFlag countryCode={country.alias.toLowerCase()} />}
        />
      ))}
    </div>
  );
};

export default CountrySwitch;
